export default __webpack_public_path__ + "static/media/1341.ada31082.png";